import { render, staticRenderFns } from "./FormDos.vue?vue&type=template&id=29f40610&scoped=true&"
import script from "./FormDos.vue?vue&type=script&lang=js&"
export * from "./FormDos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f40610",
  null
  
)

export default component.exports